// Base path for all APIs

export const DASHBOARD_ENDPOINT = `/dashboard`;

// You can define more endpoints here like:
export const TRANSACTION_ENDPOINTS = {
  LIST: `/transactions`,
  DRILLDOWN_BY_MERCHANT: (merchantName: string) =>
    `/transactions/drilldown/merchant/${merchantName}`,
};
